<template>
  <div class="card chart-card">
    <div class="card-header">
      <div class="d-flex">
        <div class="flex-grow-1">
          <div class="d-flex">
            <div class="card-title diligencePieChartTitle">Deal Flow</div>
            <div
              style="margin-left: 5px; margin-top: auto;margin-bottom: auto;"
              v-tooltip.top-end="toolTipInfo"
            >
              <img src="static/img/graphInfo.svg" class />
            </div>
          </div>
        </div>
        <div>
          <div class="d-flex">
            <div>
              <input
                class="todo-form-date todo-form form-control"
                style="margin-bottom:0px !important;height:26px;padding:0px 5px;width:121px"
                type="date"
                v-model="fromDate"
                @change="fromDateChange($event)"
              />
            </div>
            <div style="margin-left:10px;">
              <input
                class="todo-form-date todo-form form-control"
                style="margin-bottom:0px !important;height:26px;padding:0px 5px;"
                type="date"
                :min="fromDate"
                :max="todayDate"
                v-model="toDate"
                @change="toDateChange($event)"
              />
              <div class="d-flex justify-content-end">
                <div
                  class="funnelDateReset"
                  :style="(toDate.length>0 || fromDate.length>0)?'visibility:visible':'visibility:hidden'"
                  @click="changeData"
                >Reset</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body" style="padding:0px">
      <div class="d-flex justify-content-center">
        <div id="fusionChart-containerDiv"></div>
      </div>
      <div class="d-flex" style="margin-left:10%" v-if="showAcceptanceRate">
        <!-- <div
          style="font-size: 12px;color: #30334c;"
        >You have a {{acceptanceRate}}% of acceptance rate</div> -->
      </div>
    </div>
    <!-- <div class="card-footer" v-if="$slots.footer">
      <slot name="footer"></slot>
    </div>-->
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "funnelChartCard",
  computed: {
    ...mapGetters("charts", ["funnelChartData"]),
    ...mapGetters("portfolio", ["hasData", "portfolioCount"]),
    dataSource() {
      let obj = {
        chart: {
          //caption: "Deal Flow",
          //subcaption: "For the year 2017",
          theme: "fusion",
          showlabels: "1",
          showvalues: "1",
          showpercentvalues: "0",
          streamlineddata: "0",
          //plottooltext: "$label: <b>$dataValue</b>",
          plottooltext: "$label",
          // showLegend: "1",
          // legendPosition: "RIGHT",
        },
        data: this.chartData,
      };
      return obj;
    },
    acceptanceRate() {
      return this.chartData &&
        this.chartData.length > 0 &&
        Number(this.chartData[0].value) > 0
        ? (
            Number(
              (
                Number(this.chartData[this.chartData.length - 1].value) /
                Number(this.chartData[0].value)
              ).toFixed(2)
            ) * 100
          ).toFixed(2)
        : 0;
    },
    toolTipInfo() {
      return "Shows Deal flow of all the companies in workspace.";
    },
    todayDate() {
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1; //January is 0!
      var yyyy = today.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      today = yyyy + "-" + mm + "-" + dd;
      return today;
    },
    showAcceptanceRate() {
      return this.chartData &&
        this.chartData.length > 0 &&
        Number(this.chartData[0].value) > 0
        ? true
        : false;
    },
  },
  data() {
    return {
      chartData: [],
      toDate: "",
      fromDate: "",
    };
  },
  mounted() {
    this.$store.commit("charts/setFromDate", "");
    this.$store.commit("charts/setToDate", "");
    // this.chartData = this.funnelChartData;
    this.toDate = "";
    this.fromDate = "";
    this.renderFunnelChart();
  },
  methods: {
    changeData() {
      this.toDate = "";
      this.fromDate = "";
      this.$store.commit("charts/setFromDate", "");
      this.$store.commit("charts/setToDate", "");
      this.chartData = this.$store.getters["charts/funnelChartData"];
      this.renderFunnelChart();
    },
    renderFunnelChart() {
      this.chartData = this.$store.getters["charts/funnelChartData"];
      let dataValues = this.dataSource;
      FusionCharts.ready(function () {
        var myChart = new FusionCharts({
          type: "funnel",
          renderAt: "fusionChart-containerDiv",
          width: "95%",
          height: "210",
          dataFormat: "json",
          dataSource: dataValues,
        }).render();
      });
    },
    fromDateChange(event) {
      this.$store.commit("charts/setFromDate", event.target.value);
      this.$store.commit("charts/setToDate", "");
      this.toDate = "";
      this.renderFunnelChart();
    },
    toDateChange(event) {
      this.$store.commit("charts/setToDate", event.target.value);
      this.renderFunnelChart();
    },
  },
  watch: {
    portfolioCount: {
      handler(newData) {
        // updated portfolio, run update
        this.changeData();
      },
    },
  },
};
</script>
<style>
.canvasjs-chart-credit {
  display: none;
}
svg > g[class^="raphael-group-"] > text {
  display: none;
}

.funnelDateReset {
  font-size: 12px;
  color: rgb(84, 69, 243);
  cursor: pointer;
}

.funnelDateReset:hover {
  text-decoration: underline;
  cursor: pointer;
}
.raphael-group-EBXkopOo{
  display: none;
}
svg[id^="raphael-paper"] g g:first-child{
display: none;
}
</style>